import { createTheme, responsiveFontSizes } from "@mui/material/styles"

let theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#C8102E",
      light: "#E8455F",
      dark: "#8C0B1F",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#F4C300",
      light: "#F9D84A",
      dark: "#C9A227",
      contrastText: "#0D0D0D",
    },
    background: {
      default: "#0D0D0D",
      paper: "#161616",
    },
    text: {
      primary: "#F5F0E8",
      secondary: "#9E9589",
    },
    divider: "rgba(245,240,232,0.1)",
  },
  typography: {
    fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Playfair Display", "Georgia", serif',
      fontWeight: 900,
      letterSpacing: "-0.02em",
      lineHeight: 1.05,
    },
    h2: {
      fontFamily: '"Playfair Display", "Georgia", serif',
      fontWeight: 800,
      letterSpacing: "-0.015em",
      lineHeight: 1.1,
    },
    h3: {
      fontFamily: '"Playfair Display", "Georgia", serif',
      fontWeight: 700,
      letterSpacing: "-0.01em",
      lineHeight: 1.2,
    },
    h4: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      fontWeight: 700,
      letterSpacing: "-0.005em",
      lineHeight: 1.3,
    },
    h5: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h6: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      fontWeight: 600,
      lineHeight: 1.4,
    },
    body1: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      lineHeight: 1.75,
      fontWeight: 400,
    },
    body2: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      lineHeight: 1.65,
    },
    button: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      fontWeight: 700,
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      fontSize: "0.78rem",
    },
    overline: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      fontWeight: 700,
      letterSpacing: "0.2em",
      textTransform: "uppercase",
      fontSize: "0.7rem",
    },
    paragraph: {
      fontFamily: '"Inter", "Helvetica Neue", Arial, sans-serif',
      fontSize: "1rem",
      lineHeight: 1.75,
    },
  },
  shape: {
    borderRadius: 0,
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 0,
          padding: "13px 32px",
          letterSpacing: "0.1em",
          fontSize: "0.78rem",
          transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
        },
        contained: {
          "&:hover": { transform: "translateY(-1px)" },
        },
        outlined: {
          borderWidth: "2px",
          "&:hover": { borderWidth: "2px" },
        },
      },
    },
    MuiAppBar: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { boxShadow: "none" } },
    },
    MuiPaper: {
      styleOverrides: { root: { backgroundImage: "none" } },
    },
    MuiTypography: {
      styleOverrides: { gutterBottom: { marginBottom: "0.75em" } },
    },
    MuiDivider: {
      styleOverrides: { root: { borderColor: "rgba(245,240,232,0.1)" } },
    },
  },
})

theme = responsiveFontSizes(theme, { factor: 2.5 })

export default theme